import { Assignment } from "../../assignment/shared/assignment";
import { ServerEntity } from "../../rl-common/shared/shared/interfaces/server-entity";
import { Citation } from "./citation.model";

export class Section extends ServerEntity{
    name : string;
    description : string;
    indentation : number;
    order : number;
    parentList : string;
    citations : Citation[] = [];
    assignments : Assignment[] = [];
    totalPages : number;
    tags : any[] = []; //Tag[]
    publishSectionVisible : boolean;
    locker : string;
    type : 'CITATION' | 'ASSIGNMENT';

    /** Add item to collection depands on section type */
    add = (item : any) => this.myCollection().push(item);
    
    /** Remove item from collection depands on section type */
    remove = (itemIndex : any) => this.myCollection().splice(itemIndex, 1);

    readonly myCollection = () => {
        switch(this.type){
            case 'CITATION' : return this.citations;
            case 'ASSIGNMENT' : return this.assignments;
        }
     }

    get collectionSize(){
        return this.myCollection().length;
    }

    start : any;
    end : any;
    showImport : any;

    constructor(section? : any){
        super();
        if(section) Object.assign(this, section);
    }
}
